import style from '@UILayer/UILayer.scss';
import { DOM_ID } from '@UILayer/UILayer.types';
import cn from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// REDUX
import { getFreeSpins } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// IMAGES
import { Button } from '@UILayer/Inputs/Button';
import image from './free_spins_image.webp';

export const MessageFreeSpins: FC<{ onClose: Function }> = ({ onClose }) => {
    const [description, setDesc] = useState<string>('');
    const { t } = useTranslation();

    const buttonAction = (e?: React.MouseEvent<any>): void => {
        onClose();
    };

    const gameStoreFreeSpins = useAppSelector(getFreeSpins);

    useEffect(() => {
        if (gameStoreFreeSpins) {
            const desc = t('FREE_SPINS_WELCOME_MESSAGE').replace('%value', JSON.stringify(gameStoreFreeSpins.balance));
            setDesc(desc);
        }
    }, [gameStoreFreeSpins]);

    return (
        <>
            <div className={cn(style.message_icon, style.message_icon_free_spins)}>
                <img src={image} alt="" />
            </div>
            <div className={style.message_header}>{t('FREE_SPINS')}</div>
            <div className={style.message_desc}>{description}</div>
            <div className={style.message_actions}>
                <Button
                    id={DOM_ID.BUTTON_POPUP_MESSAGE_FREE_SPINS_ACCEPT}
                    description={t(`POPUP_MESSAGE_FREESPINS_ACCEPT_BUTTON_WCA_DESCRIPTION`)}
                    className={cn(style.popup_btn, style.gold_btn)}
                    onChange={() => buttonAction()}
                    dataDismiss="modal"
                >
                    {t('ACCEPT_AND_PLAY')}
                </Button>
            </div>
        </>
    );
};
